export const ACCOUNT_KEYS = {
  password: {
    reset: (resetId: string) => ["account", "password", "reset", resetId],
  },
} as const;
